﻿{
  "favoriteBoardmakerSoftware": "Software Boardmaker preferido",
  "planDetailsStartTrial": "Comece hoje seu teste grátis que inclui acesso por 30 dias!",
  "community": {
    "summary": "Aproveite as vantagens de materiais educacionais acessíveis já prontos, compartilhados por pais, educadores e terapeutas como você! Economize tempo pesquisando e filtrando atividades e modelos. Depois, basta adicioná-los à sua conta e você estará pronto para editá-los e utilizá-los com o software Boardmaker de sua preferência. Com 60.000 atividades para impressão e interativas GRÁTIS para mais de 500.000 membros: o que você está esperando?",
    "topReasons": {
      "header": "Principais razões para se cadastrar na myBoardmaker Community",
      "points": [
        "Compartilhe as atividades incríveis criadas por você",
        "Utilize poderosos recursos de pesquisa para encontrar exatamente o que precisa",
        "Encontre atividades criadas profissionalmente pela equipe educacional Boardmaker",
        "Pesquise atividades alinhadas aos padrões Common Core",
        "Participe de grupos específicos para os seus interesses"
      ]
    },
    "summaryEnd": "Compartilhe e explore materiais interativos e para impressão que oferecem suporte comportamental e promova a autonomia e o desenvolvimento das habilidades dos alunos - tudo isso GRÁTIS.",
    "features": [
      {
        "featureTitle": "Buscar",
        "featureDescription": "Encontre currículos escolares adaptados, cronogramas visuais, quadros de comunicação, atividades alinhadas aos padrões educacionais, e outros suportes que foram desenvolvidos e utilizados por pais, terapeutas e educadores."
      },
      {
        "featureTitle": "Compartilhar",
        "featureDescription": "Faça o upload de atividades criadas por você, participe de discussões, crie grupos públicos ou privados para compartilhamento e muito mais."
      },
      {
        "featureTitle": "Use o",
        "featureDescription": "Armazene suas atividades online e acesse-as de qualquer computador."
      },
      {
        "featureTitle": "Conectar",
        "featureDescription": "Conecte-se com outras pessoas que ensinam a mesma matéria ou o mesmo conteúdo do ano letivo, converse com pais que estão passando pelos mesmos desafios que você e compartilhe as soluções que você criou."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 ou mais tarde"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 ou mais tarde"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 ou mais tarde"]
      ],
      "browser": [
        ["Chrome", "v49.0", "atual"],
        ["Firefox", "v38.0", "atual"],
        ["Safari", "v11.0", "atual"],
        ["Edge", "v83.0.478.45", "atual"],
        ["Internet Explorer", "v10.0", "v11.0 ou mais tarde"]
      ]
    }
  },
  "personal": {
    "summary": "É fácil aproveitar todo o poder do Boardmaker na sua casa. A assinatura do myBoardmaker Personal permite que você assuma um papel ativo no sucesso dos seus filhos, oferecendo consistência entre casa, escola e terapia, uma opção para expandir o aprendizado para além do dia ou ano letivo. Participe da rede com outros pais na Boardmaker Community para compartilhar suas criações e ter ideias para muitas mais.",
    "topReasons": {
      "header": "Principais razões para se registrar no myBoardmaker Personal",
      "points": [
        "Acesse atividades envolventes e interativas em qualquer computador ou iPad",
        "Imprima atividades sempre que precisar",
        "Como pai ou mãe, envolva-se ativamente na educação de seus filhos em casa",
        "Leve materiais divertidos e envolventes para qualquer lugar e crie ou edite atividades a partir de qualquer computador"
      ]
    },
    "summaryEnd": "Comece hoje seu teste grátis que inclui acesso total por 30 dias!",
    "features": [
      {
        "featureTitle": "Crie e edite",
        "featureDescription": "Crie e edite atividades adaptadas por símbolos, como cronogramas visuais para planejar seu dia, livros e materiais de estudo individualizados, além de suportes comportamentais! Com uma biblioteca com mais de 80.000 símbolos para escolher, além dos novos que são adicionados a cada duas semanas. Precisa de mais? Use nossa opção de pesquisa web para importar qualquer arquivo de mídia para o seu projeto."
      },
      {
        "featureTitle": "Imprima e brinque",
        "featureDescription": "Imprima suas próprias atividades, ou qualquer uma que encontrar na Boardmaker Community, a partir do seu navegador, para usar com os seus filhos. Quer aumentar o envolvimento? Experimente nossos modelos e atividades interativos. Pais e filhos podem facilmente reproduzir atividades pelo aplicativo grátis Student Center em seu tablet ou dispositivo de comunicação."
      },
      {
        "featureTitle": "Ensine e amplie",
        "featureDescription": "Comece a desenvolver as habilidades de fala e linguagem de seus filhos acessando nossos três programas de currículo escolar fáceis de usar. Comece com o Core First Learning – uma ferramenta que ajuda seus filhos a entender o significado, o uso e o posicionamento das principais palavras de maior frequência. Ideal para pessoas que usam sistemas de comunicação ampliada baseada em núcleo ou para quem está aprendendo a ler! Use essas novas habilidades na literatura por nível de ano com o Book Bridge, e depois comece a construir o conhecimento de mundo através da história, geografia, vida e cultura com o Expedition Education."
      },
      {
        "featureTitle": "Encontre e compartilhe ",
        "featureDescription": "Por que reinventar a roda? Escolha entre mais de 60.000 modelos e atividades interativos prontos GRATUITOS, e 1.100 grupos públicos categorizados na Boardmaker Community - a maior comunidade de compartilhamento desse tipo no mundo. Você também pode fazer o upload de atividades criadas por você para a myBoardmaker Community Account, e compartilhá-la com pais, terapeutas, ou a equipe de suporte dos seus alunos."
      },
      {
        "featureTitle": "Monitore ",
        "featureDescription": "Monitore o progresso de seus filhos enquanto eles fazem atividades que garantem o sucesso deles e ajudam você a determinar a abordagem mais eficaz."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 ou mais tarde"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 ou mais tarde"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 ou mais tarde"]
      ],
      "browser": [
        ["Chrome", "v49.0", "atual"],
        ["Firefox", "v38.0", "atual"],
        ["Safari", "v11.0", "atual"],
        ["Edge", "v83.0.478.45", "atual"],
        ["Internet Explorer", "v10.0", "v11.0 ou mais tarde"]
      ]
    }
  },
  "professional": {
    "summary": "O myBoardmaker Professional é o sistema mais completo para professores de educação especial, fonoaudiólogos, terapeutas ocupacionais, terapeutas comportamentais e muitos outros, encontrarem, criarem, organizarem e fornecerem suportes visuais personalizados, comunicação com base em sinais e atividades terapêuticas que abordem as necessidades dos alunos em sua sala de aula ou seus pacientes.",
    "topReasons": {
      "header": "Principais razões para se registrar no myBoardmaker Professional",
      "points": [
        "Gerencie e passe atividades para os alunos de qualquer lugar e em qualquer computador",
        "Use a grande biblioteca de atividades de amostra alinhadas às normas ou crie as suas próprias",
        "Os alunos podem acessar as atividades educativas de qualquer computador ou iPad na escola ou em casa",
        "Colete dados e monitore o progresso dos alunos com relação aos objetivos do PEI e padrões educacionais",
        "Ferramentas integradas para ajudar você a colaborar e compartilhar com outros membros da equipe"
      ]
    },
    "summaryEnd": "Comece hoje seu teste grátis que inclui acesso total por 30 dias!",
    "features": [
      {
        "featureTitle": "Crie e edite",
        "featureDescription": "Crie e edite atividades adaptadas por símbolos, como cronogramas visuais para planejar seu dia, livros e materiais de estudo individualizados, além de suportes comportamentais! Com uma biblioteca com mais de 80.000 símbolos para escolher, além dos novos que são adicionados a cada duas semanas. Precisa de mais? Use nossa opção de pesquisa web para importar qualquer arquivo de mídia para o seu projeto."
      },
      {
        "featureTitle": "Imprima e brinque",
        "featureDescription": "Imprima suas próprias atividades, ou qualquer uma que encontrar na Boardmaker Community, a partir do seu navegador, para usar com os seus filhos. Quer aumentar o envolvimento? Experimente nossos modelos e atividades interativos. Pais e filhos podem facilmente reproduzir atividades pelo aplicativo grátis Student Center em seu tablet ou dispositivo de comunicação."
      },
      {
        "featureTitle": "Ensine e amplie",
        "featureDescription": "Ajude seus alunos a dar o próximo passo em sua jornada da educação com acesso a três programas de currículo escolar robustos e alinhado às normas. Incluso com sua assinatura myBoardmaker, o Boardmaker Instructional Solutions oferece mais de 140 planos de aula passo a passo, mais de 1500 atividades diferenciadas e alinhadas às normas, mais de 300 livros que podem ser impressos ou acessados, ferramentas de gerenciamento de sala de aula, questionários, jogos, receitas, artesanatos e muito mais!"
      },
      {
        "featureTitle": "Encontre e compartilhe",
        "featureDescription": "Por que reinventar a roda? Escolha entre mais de 60.000 modelos e atividades interativos prontos GRATUITOS, e 1.100 grupos públicos categorizados na Boardmaker Community - a maior comunidade de compartilhamento desse tipo no mundo. Você também pode fazer o upload de atividades criadas por você para a myBoardmaker Community Account, e compartilhá-la com pais, terapeutas, ou a equipe de suporte dos seus alunos."
      },
      {
        "featureTitle": "Monitore",
        "featureDescription": "Monitore o progresso de seus filhos enquanto eles fazem atividades que garantem o sucesso deles e ajudam você a determinar a abordagem mais eficaz."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 ou mais tarde"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 ou mais tarde"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 ou mais tarde"]
      ],
      "browser": [
        ["Chrome", "v49.0", "atual"],
        ["Firefox", "v38.0", "atual"],
        ["Safari", "v11.0", "atual"],
        ["Edge", "v83.0.478.45", "atual"],
        ["Internet Explorer", "v10.0", "v11.0 ou mais tarde"]
      ]
    }
  },
  "organization": {
    "summary": "O myBoardmaker Organization oferece suporte para sua equipe multidisciplinar oferecendo atividades adaptadas, suportes comportamentais e controle de progresso com relação a normas e metas. \n\nO sistema baseado em nuvem do myBoardmaker oferece uma estrutura para garantir a consistência e a colaboração ao longo de toda a instituição e permite que a equipe trabalhe de qualquer lugar. Além disso, ela oferece acesso a uma biblioteca com mais de 60.000 atividades prontas, três programas de currículo escolar integral, e mais de 80.000 símbolos de comunicação por figuras para iniciar o planejamento das lições. Agora, a sua equipe pode oferecer rapidamente atividades impressas e interativas a seus alunos ou clientes usando o Boardmaker Student Center para ampliar o aprendizado e a terapia - tudo isso clicando em apenas um botão!n\nVeja o uso da equipe e aumente a eficiência em sua instituição com a capacidade de gerenciar contas e dados centralizadamente, além das ferramentas avançadas de compartilhamento e colaboração.",
    "topReasons": {
      "header": "Principais razões para se registrar na myBoardmaker Organization",
      "points": [
        "Sistema baseado em nuvem que oferece consistência e colaboração ao longo de toda a instituição e permite que a equipe trabalhe de qualquer lugar",
        "Extensa biblioteca de modelos de atividade já alinhadas com os parâmetros College and Career Readiness Standards (parâmetros de aptidão para carreira e faculdade, em tradução livre) e suas normas estaduais específicas",
        "Os alunos podem acessar as atividades educativas de qualquer computador, em qualquer lugar",
        "As atividades podem ser associadas aos objetivos do PEI para demonstrar o progresso dos alunos",
        "Acesso imediato aos dados de desempenho do aluno e uso da equipe - tudo do mesmo sistema"
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Crie e edite",
        "featureDescription": "Crie e edite atividades adaptadas por símbolos, como cronogramas visuais para planejar seu dia, livros e materiais de estudo individualizados, além de suportes comportamentais! Com uma biblioteca com mais de 80.000 símbolos para escolher, além dos novos que são adicionados a cada duas semanas. Precisa de mais? Use nossa opção de pesquisa web para importar qualquer arquivo de mídia para o seu projeto."
      },
      {
        "featureTitle": "Imprima e brinque",
        "featureDescription": "Imprima suas próprias atividades ou qualquer uma que encontrar na Boardmaker Community, a partir do seu navegador. Quer aumentar o envolvimento? Incentive sua equipe a experimentar nossos modelos e atividades interativos. Os alunos podem facilmente reproduzir as atividades pelo aplicativo Student Center, que é gratuito, 100% e não precisa de conexão com a internet."
      },
      {
        "featureTitle": "Ensine e amplie",
        "featureDescription": "Dê à sua equipe o acesso a três programas de currículo escolar robustos e alinhado com as normas, inclusos com sua assinatura myBoardmaker Organization. O Boardmaker Instructional Solutions oferece mais de 140 planos de aula passo a passo, mais de 1500 atividades diferenciadas e alinhadas às normas, mais de 300 livros que podem ser impressos ou acessados, ferramentas de gerenciamento de sala de aula, questionários, jogos, receitas, artesanatos e muito mais!"
      },
      {
        "featureTitle": "Designe e monitore",
        "featureDescription": "Com uma myBoardmaker Organization Account, a equipe pode passar atividades personalizadas e niveladas para um número limitado de alunos e monitorar seu progresso individual considerando os objetivos do PEI e as normas estaduais e locais. Eles podem usar nossa ferramenta de Monitoramento de progresso para consultar rapidamente o desempenho de seus alunos e reportar facilmente seu progresso. As atividades passadas para casa também são monitoradas para que eles possam gerenciar a lição de casa e se comunicar eficazmente com a família da criança, ampliando o aprendizado para além da sala de aula."
      },
      {
        "featureTitle": "Encontre e compartilhe",
        "featureDescription": "Por que reinventar a roda? Escolha entre mais de 60.000 modelos e atividades interativos prontos GRATUITOS, e 1.100 grupos públicos categorizados na Boardmaker Community - a maior comunidade de compartilhamento desse tipo no mundo. Você também pode fazer o upload de atividades criadas por você para a myBoardmaker Community Account, e compartilhá-la com pais, terapeutas, ou a equipe de suporte dos seus alunos."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Economia",
        "advantagePoints": [
          "Pacotes de instituição personalizados e exclusivos para mais de 5 contas",
          "Os serviços baseados em nuvem permitem a fácil redistribuição de licenças conforme as mudanças na equipe",
          "Preço por volume",
          "Kits multiprodutos",
          "Economias por mais de um ano"
        ]
      },
      {
        "advantageTitle": "Sucesso para todos",
        "advantagePoints": [
          "As atividades prontas baseadas em pesquisas garantem resultados positivos e mensuráveis",
          "Seguindo as diretrizes do Design Universal para Aprendizagem, nossos materiais e atividades educacionais adaptados ajudam indivíduos com diversas habilidades a alcançar os objetivos de aprendizagem ",
          "Os currículos escolares adaptados oferecem um acesso igual para todos",
          "Os recursos disponíveis incluem as melhores práticas de especialistas, garantindo que você desfrute de suas soluções ao máximo"
        ]
      },
      {
        "advantageTitle": "Padrões e exigências de suporte",
        "advantagePoints": [
          "Soluções criadas especialmente para ensinar e medir o progresso em relação aos padrões de aptidão para carreira e faculdade",
          "Ampla variedade de soluções que apoiam as exigências do Design Universal para Aprendizagem e as leis Every Child Succeeds e Individuals with Disabilities Education Act.",
          "monitore e reporte o progresso em relação ao Plano de Educação Individual - automaticamente através dos painéis de dados"
        ]
      },
      {
        "advantageTitle": "Fácil implementação na instituição",
        "advantagePoints": [
          "Habilita administradores a entregarem e implementarem contas remotamente dentro de segundos",
          "Opções de implementação em instituição flexíveis e crescentes",
          "Todas as soluções baseadas em nuvem são mantidas em um centro de dados Tier 1 altamente seguro",
          "Atualizações automáticas baseadas em nuvem com novos recursos incríveis"
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 ou mais tarde"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 ou mais tarde"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 ou mais tarde"]
      ],
      "browser": [
        ["Chrome", "v49.0", "atual"],
        ["Firefox", "v38.0", "atual"],
        ["Safari", "v11.0", "atual"],
        ["Edge", "v83.0.478.45", "atual"],
        ["Internet Explorer", "v10.0", "v11.0 ou mais tarde"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "A nova geração do software Boardmaker chegou!  O Boardmaker 7 reúne os melhores recursos de todas as versões anteriores do Boardmaker e os coloca em um aplicativo multiplataformas disponíveis em diversos idiomas.  O Boardmaker 7 conta com uma interface de usuário otimizada que coloca as ferramentas que você precisa na palma da sua mão.  Ele conta com os mais recentes PCS Symbols, mas continua sendo compatível com todos seus quadros e atividades anteriores. Esse novo software permite que você crie e ofereça, mais rápido que nunca, currículos escolares adaptados e suportes à comunicação.",
    "topReasons": {
      "header": "Principais motivos para comprar o software Boardmaker 7",
      "points": [
        "Edite, imprima e reproduza todos seus arquivos antigos do Boardmaker",
        "Interface moderna e intuitiva com dicas e materiais de treinamento integrados",
        "Modelos incríveis fáceis e rápidos de personalizar",
        "Encontre rapidamente os símbolos e imagens que precisa"
      ]
    },
    "summaryEnd": "Baixe seu teste grátis por 30 dias hoje mesmo!",
    "features": [
      {
        "featureTitle": "Abre tudo que você já criou",
        "featureDescription": "Não perca todos os anos de trabalho duro... com o software Boardmaker 7, você pode abrir qualquer arquivo criado com o Boardmaker v5, o Boardmaker v6, ou com o Boardmaker Studio.  A conversão é rápida e precisa. Por isso, mesmo atividades interativas complexas funcionarão e ficarão iguais à original."
      },
      {
        "featureTitle": "Super hiper mega fácil!",
        "featureDescription": "Os usuários se manifestaram!  Com base em informações fornecidas por extensos testes de usuários com pessoas iguais a você, a interface do software Boardmaker 7 ficou moderna, convidativa e intuitiva.  As dicas e materiais de treinamento integrados deixam você confiante para explorar, expandir suas habilidades e, mais importante, oferecer suporte para seus alunos."
      },
      {
        "featureTitle": "Rápido / Economiza tempo",
        "featureDescription": "Com modelos recriados para impressões e atividades interativas, você ficará surpreso com a imensidão e profundidade do que pode conseguir em apenas alguns minutos.  Você vai acabar rapidinho aquele cronograma ou história social e assim poder dar mais atenção aos seus alunos.  Com o Boardmaker, também é mais fácil personalizar o que você criou - assim, você tem a combinação ideal de velocidade e flexibilidade."
      },
      {
        "featureTitle": "Pesquisa superior de símbolos",
        "featureDescription": "Os símbolos são nossa essência. O Boardmaker 7 conta com uma funcionalidade de pesquisa de símbolos aprimorada, e uma forma intuitiva de pesquisar símbolos por categoria... e isso é só o começo.  Você pode procurar pedaços de palavras, rimas, fonemas individuais, e padrões de consoantes/vogais. É a ferramenta de busca mais poderosa disponível!  Se por acaso você não encontrar aquele símbolo especial, a pesquisa web integrada e as ferramentas de câmera permitem adicionar fotos de uma maneira rápida e simples."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 ou mais tarde"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 ou mais tarde"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 ou mais tarde"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 ou superior"],
        ["Android", "Dispositivos Tobii Dynavox Série T", ""]
      ],
      "eyeTracker": [
        [
          "PCEye Mini,",
          "PCEye Explore,",
          "PCEye Go,",
          "EyeMobile,",
          "I-12,",
          "I–15"
        ]
      ]
    }
  }
}
